module.exports = __webpack_public_path__ + "static/img/youli.071428d5.png";